import { useEffect } from 'react';

import { Box } from '@mui/material';

import { useParams, useSearchParams } from 'react-router';
import { GX_ADDITIONAL_PAPER } from '@/constants/colors';

import FactsheetView from '@/features/Factsheet/components/FactsheetView';
import {
  ADDITIONAL_TABS_PARAM_NAME,
  FACTSHEET_PARAM_NAME,
  FACTSHEET_TAB_PARAM_NAME
} from '@/features/Factsheet/constants';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { useStorageValue } from '@/services/storage/react';
import { loginTrip } from '@/slices/tripTokenSlice';

const Factsheets = () => {
  const params = useParams();
  const factsheetKey = params[FACTSHEET_PARAM_NAME];
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const gxToken = useStorageValue('auth.gxToken');
  const dispatch = useAppDispatch();

  const additionalTabsParam = decodeURIComponent(
    urlSearchParams.get(ADDITIONAL_TABS_PARAM_NAME) ?? ''
  );
  const additionalTabs = additionalTabsParam ? additionalTabsParam.split(',') : [];

  const setAdditionalTabsParam = (tabs: string[]) => {
    const newSearchParams = new URLSearchParams(urlSearchParams);

    if (tabs.length === 0) {
      newSearchParams.delete(ADDITIONAL_TABS_PARAM_NAME);
    } else {
      newSearchParams.set(ADDITIONAL_TABS_PARAM_NAME, tabs.join(','));
    }
    if (newSearchParams.get(FACTSHEET_TAB_PARAM_NAME) !== 'Flowchart')
      newSearchParams.delete(FACTSHEET_TAB_PARAM_NAME);
    setUrlSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (gxToken) {
      dispatch(loginTrip(gxToken));
    }
  }, [dispatch, gxToken]);

  return (
    <Box
      sx={{
        backgroundColor: `${GX_ADDITIONAL_PAPER}cc`,
        display: 'flex',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      {factsheetKey && (
        <FactsheetView
          factsheetKeys={[factsheetKey, ...additionalTabs].join(',')}
          setAdditionalTabsParam={setAdditionalTabsParam}
        />
      )}
    </Box>
  );
};

export default Factsheets;
